import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';
import subscriptionFields from '../../../subscriptions/fields/subscriptionFields';

const mutationBlacklistPosTerminal = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId, blacklistStartDate }) => {
            return client.post(
                replaceParameters(POS_TERMINALS.BLACKLIST_POS_TERMINAL.url, { subscriptionId: subscriptionId }),
                { [subscriptionFields.POS_TERMINAL.BLACKLIST_START_DATE.restApiAddBlacklistKey]: blacklistStartDate }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationBlacklistPosTerminal;